"use client";

import { Search } from "lucide-react";
import BlogCard from "@/components/blog-card";
import { useBlogSearch } from "@/components/blog/search";
import { EmptyState } from "@/components/empty-state";
import { Button } from "@/components/ui/button";
import type { BlogPost } from "@/lib/blogs";

export default function BlogFilteredGrid({ posts }: { posts: BlogPost[] }) {
  const { query, filtered, setQuery } = useBlogSearch();

  const display = query
    ? filtered.map((f) => posts.find((p) => p.slug === f.slug)).filter((p): p is BlogPost => Boolean(p))
    : posts;

  if (query && filtered.length === 0) {
    return (
      <EmptyState
        title={`No posts match "${query}"`}
        description="Try a different search term or browse all posts."
        icon={Search}
        action={
          <Button
            variant="outline"
            onClick={() => setQuery("")}
            className="rounded-xl"
          >
            Clear search
          </Button>
        }
        className="py-24"
      />
    );
  }

  return (
    <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
      {display.map((post, i) => (
        <BlogCard key={post.id} post={post} priority={!query && i < 3} />
      ))}
    </div>
  );
}
